import type { ReactNode } from 'react';
import { cx } from '@/styled-system/css';
import { moduleContainer, moduleContent, moduleFooter, moduleTitle } from './module.styles';

type ModuleProps = {
  id: string;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
};

export const Module = ({ title, children, footer, className, id }: ModuleProps) => {
  return (
    <article className={cx(moduleContainer, className)} id={id}>
      {title && <h2 className={moduleTitle}>{title}</h2>}

      <div className={moduleContent} data-module-content="">
        {children}
      </div>

      {footer && <div className={moduleFooter}>{footer}</div>}
    </article>
  );
};

export type { ModuleProps };
